/**
 * Sends registration data to the Netlify Function for secure user creation.
 * @param {Object} userData - { name, username, password, promocode }
 * @returns {Promise<Object>} - The response from the serverless function
 */
export async function registerUserViaNetlify(userData) {
  try {
    const response = await fetch("/.netlify/functions/registerUser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    });

    // Check if the response is JSON before parsing
    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
      const result = await response.json();
      return result;
    } else {
      // If not JSON, read as text and return a generic error
      const text = await response.text();
      return { error: `Unexpected response: ${text}` };
    }
  } catch (error) {
    // Return an error object if the request fails
    return { error: error.message };
  }
}
